/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Home_Official_DescInputs */



/**
* | output |
* | --- |
* | "The community server. Its invite goes in as the venue." |
*
* @param {Tournament_Wiz_Home_Official_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_home_official_desc = /** @type {((inputs?: Tournament_Wiz_Home_Official_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Home_Official_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le serveur communautaire. Son invitation est reprise comme lieu.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El servidor de la comunidad. Su invitación se usa como sede.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("O servidor da comunidade. O convite dele entra como local.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il server della comunità. Il suo invito viene inserito come sede.")
	return /** @type {LocalizedString} */ ("The community server. Its invite goes in as the venue.")
});